import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { cls } from "../soft/SoftKit";

export default function HatimListEmpty() {
  const { t } = useScriptMode();
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3 px-4">
      <MenuBookOutlinedIcon sx={{ fontSize: 56 }} className={cls.faint} />
      <div className={`text-lg font-Medium text-center ${cls.heading}`}>{t("hatim_empty_title")}</div>
      <div className={`text-sm text-center max-w-sm ${cls.muted}`}>{t("hatim_empty_body")}</div>
    </div>
  );
}
